
import SelectActiveBtn from "./SelectActiveBtn/SelectActiveBtn";
import SelectGroupedAction from "./SelectGroupedAction/SelectGroupedAction";
import SpendingDemandListComponent from "./SpendingDemandList_new";
import { SpendingDemandListPresenterV2 } from "./SpendingDemandList_new/SpendingDemandListPresenterV2";
import SpendingDemandListFilterPresenter from "./SpendingDemandListFilter/SpendingDemandListFilterPresenter";
const SpendingDemandList = {
    List : SpendingDemandListComponent,
    Filter : SpendingDemandListFilterPresenter,
    SelectActiveBtn: SelectActiveBtn,
    GroupedActionBtn: SelectGroupedAction,
    ListManager: SpendingDemandListPresenterV2

}

export default SpendingDemandList;